import { useState } from "react";

export const useLanguage = () => {
  const [isLanguageModalShow, setIsLanguageModalShow] =
    useState<boolean>(false);

  const handleSetIsLanguageModalShow = (value: boolean | string | number) => {
    setIsLanguageModalShow(Boolean(value));
  };

  return {
    isLanguageModalShow,
    setIsLanguageModalShow: handleSetIsLanguageModalShow,
  };
};
